import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { Link } from '~/shared/components/Link';
import { breakpoints } from '~/theme';

export const Text = styled.p<{ isBold?: boolean; isTitle?: boolean; paddingTop?: boolean }>(
    ({ theme }) => ({
        fontSize: theme.fontSizes.mouse,
        lineHeight: theme.lineHeights.chicken,
        color: theme.colors.nightBlack,
        whiteSpace: 'pre-wrap',

        ':not(:last-child)': {
            marginBottom: theme.space[2],
        },
    }),
    ifProp('isTitle', ({ theme }) => ({
        fontWeight: theme.fontWeights.medium,
        paddingBottom: theme.space[1],

        [breakpoints.md]: {
            paddingBottom: theme.space[2],
        },
    })),
    ifProp('paddingTop', ({ theme }) => ({
        paddingTop: theme.space[6],

        [breakpoints.md]: {
            paddingTop: theme.space[5],
        },
    })),
);

export const LinkText = styled(Link)(({ theme }) => ({
    fontSize: theme.fontSizes.mouse,
    lineHeight: theme.lineHeights.chicken,
    color: theme.colors.nightBlack,
}));

export const ListWrapper = styled.ul(({ theme }) => ({
    marginTop: theme.space[5],
    display: 'grid',
    gap: theme.space[2],
}));

export const ListItem = styled.li(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.space[1],

    svg: {
        width: theme.space[4],
        height: theme.space[4],
    },
}));

export const SustainabilityWrapper = styled.ul(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.space[3],
}));

export const SustainabilityValue = styled.li(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.space[3],

    [':not(:last-child)']: {
        borderBottom: `1px solid ${theme.colors.grey50}`,
        paddingBottom: theme.space[3],
    },
}));

export const SustainabilityIcon = styled.div(({ theme }) => ({
    width: theme.space['7'],
    height: theme.space['7'],
}));

export const SustainabilityValueHeadline = styled(Text)(() => ({
    margin: '0',
    padding: '0',

    [breakpoints.md]: { margin: '0', padding: '0' },

    [':not(:last-child)']: { margin: '0', padding: '0' },
}));
